import { cachedFetch, endpointWrapper, paginator } from './meta.api';

export const fetchCategories = paginator((...args) => {
    return cachedFetch(endpointWrapper)({ domain: 'categories', ...args[0] });
});

export const fetchProducts = paginator((...args) => {
    return cachedFetch(endpointWrapper)({ domain: 'products', ...args[0] });
});

export const fetchAffinities = paginator((...args) => {
    return cachedFetch(endpointWrapper)({ domain: 'affinities', ...args[0] });
});

export const fetchBrands = paginator((...args) => {
    return cachedFetch(endpointWrapper)({ domain: 'brands', ...args[0] });
});

export const fetchDataPoints = paginator((...args) => {
    return cachedFetch(endpointWrapper)({ domain: 'data_points', ...args[0] });
});

export const fetchKeywords = paginator((...args) => {
    return cachedFetch(endpointWrapper)({ domain: 'keywords', ...args[0] });
});

export const fetchItems = (options, paginatorOptions) =>
    paginator((...args) => {
        return cachedFetch(endpointWrapper)({ ...args[0] });
    }, paginatorOptions)(options);

export const fetchWeeklyGoogleTimeSeries = (...args) =>
    endpointWrapper({
        domain: 'search/timeseries/weekly',
        ...args[0],
    });
